import React from "react";
import PanelHead from "../../Panel/PanelHead";
import PanelBody from "../../Panel/PanelBody";
import { FormAddEmailProvider } from "./FormAddEmailProvider";

export const PanelAddEmailProvider = () => {
  return (
    <div>
      {" "}
      <PanelHead
        title={
          <div className="flex items-center justify-between w-full gap-4">
            <div>Add Email Provider</div>
          </div>
        }
      />
      <PanelBody content={<FormAddEmailProvider />} />
    </div>
  );
};
